import { themed } from '@indeed/ifl-css';

const CARD_SECTION_DEFAULT_TAG = "div";
const CardSection = /*#__PURE__*/themed(CARD_SECTION_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e1gufzzf0"
} : {
  styleProps: [],
  target: "e1gufzzf0",
  label: "CardSection"
})(() => ({
  paddingBlockStart: 4,
  paddingBlockEnd: 4,
  paddingInlineStart: 4,
  paddingInlineEnd: 4,
  ":not(:last-of-type)": {
    borderBlockEnd: "1px solid transparent",
    borderBlockEndColor: "border.weak"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRTZWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZMkIiLCJmaWxlIjoiQ2FyZFNlY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5pbXBvcnQgKiBhcyBQb2x5bW9ycGhpYyBmcm9tIFwiLi4vLi4vdHlwZXMvcG9seW1vcnBoaWNcIjtcblxuZXhwb3J0IGNvbnN0IENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRyA9IFwiZGl2XCI7XG5cbmV4cG9ydCB0eXBlIENhcmRTZWN0aW9uID0gU3R5bGVQcm9wcztcbmV4cG9ydCB0eXBlIENhcmRTZWN0aW9uQ29tcG9uZW50ID0gUG9seW1vcnBoaWMuQ29tcG9uZW50PFxuICB0eXBlb2YgQ0FSRF9TRUNUSU9OX0RFRkFVTFRfVEFHLFxuICBDYXJkU2VjdGlvblxuPjtcblxuZXhwb3J0IGNvbnN0IENhcmRTZWN0aW9uID0gdGhlbWVkKENBUkRfU0VDVElPTl9ERUZBVUxUX1RBRywge1xuICBzdHlsZVByb3BzOiBbXVxufSkoKCkgPT4gKHtcbiAgcGFkZGluZ0Jsb2NrU3RhcnQ6IDQsXG4gIHBhZGRpbmdCbG9ja0VuZDogNCxcbiAgcGFkZGluZ0lubGluZVN0YXJ0OiA0LFxuICBwYWRkaW5nSW5saW5lRW5kOiA0LFxuICBcIjpub3QoOmxhc3Qtb2YtdHlwZSlcIjoge1xuICAgIGJvcmRlckJsb2NrRW5kOiBcIjFweCBzb2xpZCB0cmFuc3BhcmVudFwiLFxuICAgIGJvcmRlckJsb2NrRW5kQ29sb3I6IFwiYm9yZGVyLndlYWtcIlxuICB9XG59KSkgYXMgQ2FyZFNlY3Rpb25Db21wb25lbnQ7XG5cbkNhcmRTZWN0aW9uLmRpc3BsYXlOYW1lID0gXCJDYXJkU2VjdGlvblwiO1xuIl19 */");
CardSection.displayName = "CardSection";

export { CARD_SECTION_DEFAULT_TAG, CardSection };
